import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../../axios";
import handleApiError from "../../../utils/handleApiError";
import FullPageLoader from "../../components/FullPageLoader";

export default function CategoryDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState(null);
    const [error, setError] = useState("");

    const fetchCategory = async () => {
        try {
            const res = await axios.get(`/admin/categories/${id}`);
            setCategory(res.data);
        } catch (err) {
            setError(handleApiError(err));
        }
    };

    useEffect(() => {
        fetchCategory();
    }, [id]);

    const handleDelete = async () => {
        if (!window.confirm("Yakin ingin menghapus kategori ini?")) return;

        try {
            await axios.delete(`/admin/categories/${id}`);
            navigate("/admin/categories");
        } catch (err) {
            alert(handleApiError(err));
        }
    };

    if (error) return <p style={{ color: "red" }}>{error}</p>;
    if (!category) return <FullPageLoader />;

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Detail Kategori</h4>
            </div>
            <div className="card-body">
                <p><strong>Nama:</strong> {category.name}</p>
                <p><strong>Slug:</strong> {category.slug}</p>
                <p><strong>Prefix:</strong> {category.prefix}</p>
                <p><strong>Jumlah SubKategori:</strong> {category.sub_categories.length}</p>

                <div style={{ marginTop: "1rem" }}>
                    <button className="btn btn-warning py-9" onClick={() => navigate(`/admin/categories/${id}/edit`)} >Edit</button>
                    <button className="btn btn-danger py-9" onClick={handleDelete} style={{ marginLeft: "0.5rem" }}>Delete</button>
                    <button className="btn btn-secondary py-9" onClick={() => navigate("/admin/categories")} style={{ marginLeft: "0.5rem" }}>Kembali</button>
                </div>

                <hr />
                <h3 className="mb-2">SubKategori</h3>
                <ul>
                    {category.sub_categories.map((sub) => (
                        <li key={sub.id}>
                            <span>{sub.name}</span><br />
                            <small style={{fontWeight: '700'}}>Prefix: {sub.prefix}</small>
                            <hr />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
